module.exports = __webpack_public_path__ + "img/wisetokenitalia.0278093c.png";